/* eslint-disable react/jsx-props-no-spreading */
import FormControlLabel from 'components/Form/Control/FormControlLabel';
import React, { forwardRef } from 'react';
import { DatePicker, Form } from 'rsuite';
import clsx from 'clsx';
import layoutStyles from 'components/Form/FormFieldLayout.module.scss';

const DatePickerFormField = forwardRef((props: any, ref: any) => {
  const { size, name, helpMessage, label, required, value, onChange } =
    props;

  return (
    <Form.Group
      ref={ref}
      className={clsx(
        layoutStyles.formGroup,
        size === 'sm' && layoutStyles.formGroupSm,
      )}
    >
      <FormControlLabel required={required || false}>
        {label}{' '}
      </FormControlLabel>
      <div className={layoutStyles.controlWrapper}>
        <Form.Control
          format="MM/dd/yyyy"
          placeholder="mm/dd/yyyy"
          style={{ width: '100%' }}
          name={name}
          accepter={DatePicker}
          value={value}
          onChange={onChange}
          oneTap
          aria-hidden="true"
        />
        {helpMessage ? <Form.HelpText>{helpMessage}</Form.HelpText> : null}
      </div>
    </Form.Group>
  );
});

export default DatePickerFormField;
